import { DbListBase } from './db-list-base';
import { DbLotteryFilter, DbLotteryFilterParam } from './db-lottery-filter';
import { ICollectionReference } from '../database-cast/IDatabase';

export class DbCustomerLotteryFilters extends DbListBase<any> {
   // private _collection: ICollectionReference;

    constructor(collection: ICollectionReference) {
        super(collection);
    //    this._collection = collection;
    }

    // public getParams() {
    //     let params = new DbCustomerLotteryFiltersParams(this._collection.doc("params"));

    //     return params;
    // }

    public getFilter(id:string) {
        let params = new DbLotteryFilter(id,this._collection);

        return params;
    }

}

